var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Kevin Nguyen <kevin@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useState } from "react";
var defaultContext = {
    lastCreatedResource: null,
    setLastCreatedResource: function () { return undefined; },
};
export var NewResourceContext = createContext(defaultContext);
export default function NewResourceContextProvider(_a) {
    var children = _a.children;
    var _b = useState(null), lastCreatedResource = _b[0], setLastCreatedResource = _b[1];
    return (_jsx(NewResourceContext.Provider, __assign({ value: {
            lastCreatedResource: lastCreatedResource,
            setLastCreatedResource: setLastCreatedResource,
        } }, { children: children })));
}
